import { render, staticRenderFns } from "./AppChanges.vue?vue&type=template&id=13edab08&scoped=true&"
import script from "./AppChanges.vue?vue&type=script&lang=js&"
export * from "./AppChanges.vue?vue&type=script&lang=js&"
import style0 from "./AppChanges.vue?vue&type=style&index=0&id=13edab08&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13edab08",
  null
  
)

export default component.exports